module.exports = __webpack_public_path__ + "media/images/flags/16/Wales-6a80fa4c45c963ba75504fcc28d2eaf8.png";